import { render, staticRenderFns } from "./editPassWord.vue?vue&type=template&id=2161ce3e&"
import script from "./editPassWord.vue?vue&type=script&lang=js&"
export * from "./editPassWord.vue?vue&type=script&lang=js&"
import style0 from "./editPassWord.vue?vue&type=style&index=0&id=2161ce3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports